module.exports = __webpack_public_path__ + "static/img/index-service4.45a33c3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/index-service4.png
// module id = 6NbC
// module chunks = 8